import { render, staticRenderFns } from "./PalestraView.vue?vue&type=template&id=74360af7&"
import script from "./PalestraView.vue?vue&type=script&lang=js&"
export * from "./PalestraView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports